import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";
import { cva, type VariantProps } from "class-variance-authority";

const decoratedIconVariants = cva("flex size-6 items-center justify-center rounded-sm", {
    variants: {
        variant: {
            default: "bg-neutral-100 text-neutral-500",
            blue: "bg-blue-100 text-blue-500",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});

export interface DecoratedIconProps extends VariantProps<typeof decoratedIconVariants> {
    icon: LucideIcon;
    className?: string;
}

const DecoratedIcon = ({ icon: Icon, className, variant }: DecoratedIconProps): JSX.Element => {
    return (
        <div className={cn(decoratedIconVariants({ variant }), className)}>
            <Icon className="size-4" />
        </div>
    );
};

export { DecoratedIcon, decoratedIconVariants };
